<template>
  <c-container class="d-flex align-items-center min-vh-100">
    <c-row class="w-100 justify-content-center">
      <c-col md="6">
        <div class="w-100">
          <div class="clearfix">
            <h1 class="float-left text-h2 mr-4">404</h1>
            <h4 class="pt-3">Oops! You're lost.</h4>
            <p class="text-muted">The page you are looking for was not found.</p>
          </div>
          <c-input class="mb-3" placeholder="What are you looking for?">
            <template #prepend-content><c-icon name="cil-magnifying-glass" /></template>
            <template #append>
              <c-button color="info">Search</c-button>
            </template>
          </c-input>
        </div>
      </c-col>
    </c-row>
  </c-container>
</template>

<script>
export default {
  name: 'Page404',
};
</script>
